import { render, staticRenderFns } from "./ClaimDetailDialog.vue?vue&type=template&id=22bf845e&scoped=true"
import script from "./ClaimDetailDialog.vue?vue&type=script&lang=js"
export * from "./ClaimDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./ClaimDetailDialog.vue?vue&type=style&index=0&id=22bf845e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf845e",
  null
  
)

export default component.exports